export const replaceHyphenBySpace = (url: string): string => {
  return url ? url.replace(/\-/g, ' ') : null;
};
